import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './popup.scss';
import { IconType } from '../../atoms/icon/icon';
import InputText from '../../atoms/inputText/inputText';

/**
 * Help button is a Button associate to popup paragraph with a help text.
 */
const Popup = (props) => {
  const {
    id,
    onChange,
    value,
    type,
  } = props;
  const [displayHelp, setDisplayHelp] = useState(false);
  const [inputValue, setInputValue] = useState();

  const childRef = useRef();

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  const handleClick = () => {
    onChange(inputValue);
    setDisplayHelp(false);
  };
  const onClickButton = () => {
    setDisplayHelp(!displayHelp);
  };

  return (
    <div className="d-inline position-relative">
      <Button
        id={id}
        type={ButtonType.BUTTON}
        theme={ButtonTheme.SECONDARY}
        icon={IconType.SORT}
        onClick={onClickButton}
        className="mr-1"
      />
      {displayHelp && (
        <div onBlur={handleClick} className={`popover popup__popover text-dark ${displayHelp ? 'popover popup__popover--block' : ''}`}>
          <div className="popover-content pt-3 px-2 popup__content" id="popup">
            <InputText
              ref={childRef}
              name={`${id}-popup`}
              type={type}
              value={value}
              onChange={handleChange}
              autoComplete={false}
              autoFocus
            />
            <div className="popup__button">
              <Button
                className="p-2"
                theme={ButtonTheme.SUCCESS}
                icon={IconType.EDIT}
                onClick={handleClick}
              />
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

Popup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  type: PropTypes.node,
};

Popup.defaultProps = {
  onChange: () => {},
  value: '',
  id: -1,
  type: null,
};

export default Popup;
